import { useEffect, useState } from "react";

export function useTicketSeries() {
  const [series, setSeries] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    
    fetch("/api/analytics/tickets/series")
      .then(r => r.json())
      .then(d => !cancelled && setSeries(d.series || []))
      .catch(error => {
        if (!cancelled) {
          console.error('Failed to fetch ticket series:', error);
          setSeries([]);
        }
      })
      .finally(() => !cancelled && setLoading(false));
    
    return () => { cancelled = true; };
  }, []);
  
  return { series, loading };
}

export function useTicketKpis() {
  const [kpis, setKpis] = useState<any>(null);
  
  useEffect(() => {
    let cancelled = false;
    
    fetch("/api/analytics/tickets/kpis")
      .then(r => r.json())
      .then(d => !cancelled && setKpis(d.kpis || null))
      .catch(error => {
        if (!cancelled) {
          console.error('Failed to fetch ticket KPIs:', error);
          setKpis(null);
        }
      });
    
    return () => { cancelled = true; };
  }, []);
  
  return { kpis };
}
